import { isPriceTypeHidden } from '%evp_ticket_frontend/js/redux/currentEvent/service/visibilityChecker';

function getDefaultPriceType(priceTypes) {
    const applicablePriceTypes = priceTypes.filter(price => !isPriceTypeHidden(price));
    if (applicablePriceTypes.length === 0) {
        return null;
    }
    const defaultPrice = applicablePriceTypes.find(priceType => priceType.selected_by_default);

    return defaultPrice || applicablePriceTypes[0];
}

export default getDefaultPriceType;
